const UTMS = {
  utm_source: 'utmSource',
  utm_campaign: 'utmCampaign',
  utm_term: 'utmTerm',
  utm_content: 'utmContent'
}

export default UTMS
